var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationBlue = function SvgLocationBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15625 0C3.28625 0 0.15625 3.13 0.15625 7C0.15625 12.25 7.15625 20 7.15625 20C7.15625 20 14.1562 12.25 14.1562 7C14.1562 3.13 11.0262 0 7.15625 0ZM7.15625 9.5C5.77625 9.5 4.65625 8.38 4.65625 7C4.65625 5.62 5.77625 4.5 7.15625 4.5C8.53625 4.5 9.65625 5.62 9.65625 7C9.65625 8.38 8.53625 9.5 7.15625 9.5Z",
    fill: "#266BEE"
  })));
};
export default SvgLocationBlue;